import { palette, TemplateWithoutScreenshot } from "@dev/ee-components";
import { isEmpty } from "lodash-es";
import React from "react";
import { useTranslation } from "react-i18next";
import { EmptyImageState, ImagePreviewWrapper, PageDataText, PageDataWrapper, SocialPreviewWrapper } from "./styledComponents";
import { SocialPreviewProps } from "./types";

export const SocialPreview = (props: SocialPreviewProps): JSX.Element => {
    const { imageUrl, pageUrl, pageTitle, pageDescription, isEdit } = props;
    const { t } = useTranslation();
    
    return (
        <SocialPreviewWrapper isEdit={isEdit}>
            {!imageUrl ? (
                <EmptyImageState>
                    <TemplateWithoutScreenshot />
                </EmptyImageState>
            ) : (
                <ImagePreviewWrapper>
                    <img src={imageUrl} />
                </ImagePreviewWrapper>
            )}
            <PageDataWrapper>
                <PageDataText style={{ marginBottom: 8, fontWeight: 500 }}>
                    {pageUrl?.toUpperCase()}
                </PageDataText>
                <PageDataText style={{ marginBottom: 8, fontWeight: 700, color: palette.jacarta[5] }}>
                    {!isEmpty(pageTitle) ? pageTitle : t('lp_creator_social_pagetitle_placeholder')}
                </PageDataText>
                <PageDataText>
                    {!isEmpty(pageDescription) ? pageDescription : t('lp_creator_social_pagedescription_placeholder')}
                </PageDataText>
            </PageDataWrapper>
        </SocialPreviewWrapper>
    )
}